module.exports = __webpack_public_path__ + "img/aerospace-paths.89e586cd.jpg";